import React from "react";

export default function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_677_260)">
        <path
          d="M18.3334 18.3333L16.6668 16.6666M1.66675 9.58329C1.66675 5.21104 5.21116 1.66663 9.58342 1.66663C13.9557 1.66663 17.5001 5.21104 17.5001 9.58329C17.5001 13.9555 13.9557 17.5 9.58342 17.5C5.21116 17.5 1.66675 13.9555 1.66675 9.58329Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_677_260">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
